import { render } from "./TransferForm.vue?vue&type=template&id=1bc9c24b"
import script from "./TransferForm.vue?vue&type=script&lang=js"
export * from "./TransferForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Cards/Forms/TransferForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bc9c24b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bc9c24b', __exports__)) {
    api.reload('1bc9c24b', __exports__)
  }
  
  module.hot.accept("./TransferForm.vue?vue&type=template&id=1bc9c24b", () => {
    api.rerender('1bc9c24b', render)
  })

}


export default __exports__